module.exports = __webpack_public_path__ + "img/document_icon.608bf01d.svg";